import {IntrospectionInterfaceType, IntrospectionType, IntrospectionUnionType} from 'graphql';
import _ from 'underscore';

import GraphQLIntrospectionResult from 'graphql-client/schema/GraphQLIntrospectionResult';

const typeDefs = GraphQLIntrospectionResult.__schema.types;

export type IntrospectionAbstractType = IntrospectionUnionType | IntrospectionInterfaceType;

export function typeIsAbstract(typeDef: {kind: string}): typeDef is IntrospectionAbstractType {
  return typeDef.kind === 'UNION' || typeDef.kind === 'INTERFACE';
}

export function typeIsPossiblyInaccessibleInfo(typeDef: IntrospectionType): boolean {
  return typeIsAbstract(typeDef) && typeDef.possibleTypes.some(({name}) => name === 'InaccessibleInfoNode');
}

export const getTypesByName: () => {[typeName: string]: IntrospectionType} = _.once(() =>
  _.indexBy(typeDefs, (type) => type.name)
);
